import { memo } from 'react'
import { cx } from '@utils/cx'
import styles from './Tile.module.css'

function Tile ({
  tileValue,
  index,
  isEmpty,
  movable,
  imageSrc,
  size,
  srLabel,
  onClick
}) {
  if (isEmpty) {
    return (
      <div
        className={cx(styles.tile, styles.isEmpty)}
        role='gridcell'
        aria-label={srLabel}
      />
    )
  }

  // Sprite math: background-size = size*100% → positions at col/(size-1)
  const pieceRow = Math.floor(tileValue / size)
  const pieceCol = tileValue % size

  return (
    <button
      type='button'
      className={cx(styles.tile, movable && styles.isMovable)}
      role='gridcell'
      aria-label={srLabel}
      disabled={!movable}
      onClick={movable ? () => onClick(index) : undefined}
      style={{
        backgroundImage: `url(${imageSrc})`,
        backgroundSize: `${size * 100}% ${size * 100}%`,
        backgroundPosition: `${(pieceCol / (size - 1)) * 100}% ${(pieceRow / (size - 1)) * 100}%`
      }}
    />
  )
}

const areEqual = (prev, next) =>
  prev.tileValue === next.tileValue &&
  prev.index === next.index &&
  prev.isEmpty === next.isEmpty &&
  prev.movable === next.movable &&
  prev.srLabel === next.srLabel

export default memo(Tile, areEqual)
